module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/suns_title_decoration-09f42fa409f67100e35823ae0f3ab2a6.svg";